const styles = {
  menu: baseCSS => ({
    ...baseCSS,
    zIndex: '10',
    width: 'unset',
    minWidth: '100%',
  }),
  dropdownIndicator: baseCSS => ({
    ...baseCSS,
    padding: '0px 5px',
  }),
  clearIndicator: baseCSS => ({
    ...baseCSS,
    padding: '0px 5px',
  }),
  valueContainer: baseCSS => ({
    ...baseCSS,
    padding: '0px 8px',
  }),
  control: baseCSS => ({
    ...baseCSS,
    minHeight: '35px',
  }),
  input: baseCSS => ({
    ...baseCSS,
    padding: '0px',
  }),
  placeholder: baseCSS => ({
    ...baseCSS,
    color: '#C2C2C2',
  }),
}

const stylesSmall = {
  ...styles,
  menu: baseCSS => ({
    ...baseCSS,
    fontSize: '12px',
  }),
  valueContainer: baseCSS => ({
    ...baseCSS,
    padding: '0px 6px',
  }),
  control: baseCSS => ({
    ...baseCSS,
    minHeight: '30px',
    fontSize: '12px',
  }),
  dropdownIndicator: baseCSS => ({
    ...baseCSS,
    padding: '0px 5px',
    transform: 'scale(0.8)',
  }),
}

const onBlurFormik = input => input.onBlur

const onChangeFormikSingle = input => e => input.onChange(e ? e.value : null)
const onChangeFormikMulti = input => values =>
  input.onChange(values ? values.map(({ value }) => value) : [])

export default {
  styles,
  stylesSmall,
  onBlurFormik,
  onChangeFormikSingle,
  onChangeFormikMulti,
}
